"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBusiness = function IconBusiness(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M37 5H11v13.75l-.011.224c-.018.973.356 1.98 1.053 2.755a4.1 4.1 0 0 0 2.932 1.35 4.08 4.08 0 0 0 3.035-1.387l.033.037a4.1 4.1 0 0 0 2.932 1.35 4.08 4.08 0 0 0 3.035-1.387l.033.037a4.1 4.1 0 0 0 2.932 1.35 4.09 4.09 0 0 0 2.835-1.174q.109.146.233.284A4.1 4.1 0 0 0 32 23.396V41H15v2h19V23.399a4.04 4.04 0 0 0 1.968-1.201 4.06 4.06 0 0 0 1.028-3.076L37 10.12zm-2 5.12h-4l-.003 8.554q.033.384-.006.762a2.1 2.1 0 0 0 .537 1.414c.383.426.925.675 1.456.69a2.06 2.06 0 0 0 1.498-.68c.345-.384.533-.88.527-1.455L35 19.21zm-6 0h-4l-.003 8.552q.025.287.009.571c.051.424.232.825.522 1.147.383.426.925.675 1.456.69A2.05 2.05 0 0 0 29 19.184V10.12m-6 0h-4l-.003 8.552q.025.287.009.571c.051.424.232.825.522 1.147.383.426.925.675 1.456.69a2.06 2.06 0 0 0 1.498-.68 2.04 2.04 0 0 0 .512-1.156q-.008-.135-.005-.27L23 18.75zm-6 0h-4l-.003 8.708a2.1 2.1 0 0 0 .53 1.562c.384.426.926.675 1.457.69a2.06 2.06 0 0 0 1.498-.68 2.04 2.04 0 0 0 .512-1.156q-.008-.135-.005-.27L17 18.75zM35 7v1.12H13V7zm-5.346 25.007-5.07-5.07-.707.707 5.07 5.07zm-8.46-4.21 7.6 7.59-.707.707-7.6-7.59zm4.21 8.45-5.06-5.07-.708.706 5.06 5.07z",
    clipRule: "evenodd"
  })));
};

export { IconBusiness, IconBusiness as default };
